import i18n from '../i18n'

export const ROLE_HOME = {
  student: '/student-home/',
  teacher: '/teacher-home/',
  curator: '/teacher-home/',
  head_of_department: '/admin/',
  dean: '/admin/',
  methodist: '/admin/',
  hr_students: '/admin/',
  hr_employees: '/admin/',
  accountant: '/admin/',
  archivist: '/archive/',
  rectorate: '/admin/',
  sysadmin: '/admin/',
  parent: '/student-home/',
  // P1-A1: раньше applicant попадал на /home/ (MainPage), который рассчитан на
  // сотрудников с задачами/заявлениями — для абитуриента это был пустой UI.
  // Теперь у роли есть собственная домашняя страница.
  applicant: '/applicant-home/',
  // Wave 4: добавлены роли из Wave 2A SYSTEM_ROLES.
  // FIX (Промежуток): foreign_student попадал на /foreign-students/, который
  // защищён HR_STUDENTS — иностранный студент получал 403 на собственной home.
  // Сейчас foreign_student/postgrad/dpo_student идут на /student-home/, где
  // STUDENT_HOME_ROLES их пропускает.
  foreign_student: '/student-home/',
  postgrad: '/student-home/',
  dpo_student: '/student-home/',
  dorm_staff: '/dorm/',
  // FIX (Промежуток): /profile/ — несуществующий роут; используем
  // /personalcard/ (доступна всем залогиненным).
  proctor: '/personalcard/',
}

export function homePathByRoles(roles = [], primaryRole = null) {
  const codes = (Array.isArray(roles) ? roles : [])
    .map((r) => (typeof r === 'string' ? r : r?.code))
    .filter(Boolean)
  if (primaryRole && ROLE_HOME[primaryRole]) return ROLE_HOME[primaryRole]
  // Wave 4: порядок приоритета сохранён, добавлены новые роли в конец
  // (приоритет ниже стандартных, но выше fallback /home/).
  for (const c of [
    'sysadmin', 'rectorate', 'dean', 'methodist',
    'hr_students', 'hr_employees', 'accountant', 'archivist',
    'head_of_department', 'curator', 'teacher',
    'dorm_staff', 'proctor',
    'student', 'foreign_student', 'postgrad', 'dpo_student',
    'parent', 'applicant',
  ]) {
    if (codes.includes(c)) return ROLE_HOME[c] || '/home/'
  }
  // Дефолт: если роли не распознаны — на /login (избегаем бесконечных редиректов
  // на /home/ для пользователя без ролей).
  return codes.length > 0 ? '/home/' : '/login'
}

export function formatLockedMessage(lockedUntilIso) {
  if (!lockedUntilIso) return i18n.t('utils.roleRedirect.lockedTemp')
  try {
    const dt = new Date(lockedUntilIso)
    return i18n.t('utils.roleRedirect.lockedUntil', {
      date: dt.toLocaleString('ru-RU'),
    })
  } catch {
    return i18n.t('utils.roleRedirect.locked')
  }
}
